import { render, staticRenderFns } from "./LabelInfo.vue?vue&type=template&id=01603ed8&scoped=true&"
import script from "./LabelInfo.vue?vue&type=script&lang=js&"
export * from "./LabelInfo.vue?vue&type=script&lang=js&"
import style0 from "./LabelInfo.vue?vue&type=style&index=0&id=01603ed8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01603ed8",
  null
  
)

export default component.exports